import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {  Cookies } from 'react-cookie';
import ChangeMarketerMode from './ChangeMarketerMode';
import ChangeLeaderMode from './ChangeLeaderMode';
import ChangeMarketerComission from './ChangeMarketerComission';
import ChangeLeaderComission from './ChangeLeaderComission';
import ChangeMarketerRequest from './ChangeMarketerRequest';
import ChangeMarketerReject from './ChangeMarketerReject';
import ChangeMarketerActive from './ChangeMarketerActive';



const styles = theme => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
  , paper: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(20),
      },
    },


});

class ChangeMarketer extends Component {
  cookies=new Cookies();
  constructor(props) {
      super(props);
    this.state = {
  value:0,
}}

componentDidMount() {

}
handleChange= (event,newValue) => {
  this.setState({ value:newValue });
}
    render() {
      const { classes } = this.props;
      const { value } = this.state;
        let roles = this.cookies.get("roles") || "[]";
        console.log("roles", roles); // ["admin", "editor", "viewer"]
        const isMali = roles.includes("واحد مالی");
        return (
            <div>
                 <AppBar position="sticky"color="primary" >

                     <Tabs
                         style={{height:'60px', textAlign:'center'}}
                         value={value}
                         onChange={this.handleChange}
                         indicatorColor="secondary"
                         variant="scrollable"
                         scrollButtons="auto"
                     >
                         {!isMali && <Tab label="درخواست های بازاریابی" />}
                         {!isMali && <Tab label="بازاریابان بررسی شده" />}
                         {!isMali && <Tab label="بازاریابان رد شده" />}
                         {!isMali && <Tab label="انواع بازاریاب" />}
                         {!isMali && <Tab label="انواع لیدر بازاریاب" />}

                         {/* اگر مالی بود فقط این 2 تا نمایش داده میشه */}
                         <Tab label="درصد پیشفرض بازاریابی" />
                     </Tabs>



                 </AppBar>
                {isMali && value === 0 && <ChangeMarketerComission props={this.props} />}

                {!isMali && value === 0 && <ChangeMarketerRequest props={this.props} />}
                {!isMali && value === 1 && <ChangeMarketerActive props={this.props} />}
                {!isMali && value === 2 && <ChangeMarketerReject props={this.props} />}
                {!isMali && value === 3 && <ChangeMarketerMode props={this.props} />}
                {!isMali && value === 4 && <ChangeLeaderMode props={this.props} />}
                {!isMali && value === 5 && <ChangeMarketerComission props={this.props} />}
                {!isMali && value === 6 && <ChangeLeaderComission props={this.props} />}


               </div>
        );
    }
}

export default  withStyles(styles)(ChangeMarketer);
